import { createContext } from 'react';
import type { AuthContextValue } from '../authTypes';

// Type only — pas de JSX ici
export const AuthContext = createContext<AuthContextValue | null>(null);
